import api from './client';

export interface Contact {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  organization: string;
  notes: string;
}

export const getContacts = (params?: Record<string, unknown>) =>
  api.get<{ results: Contact[]; count: number }>('/contacts/', { params }).then((r) => r.data);

export const createContact = (data: Partial<Contact>) =>
  api.post<Contact>('/contacts/', data).then((r) => r.data);

export const updateContact = (id: number, data: Partial<Contact>) =>
  api.patch<Contact>(`/contacts/${id}/`, data).then((r) => r.data);

export const deleteContact = (id: number) => api.delete(`/contacts/${id}/`);

export const exportContactsCsv = async () => {
  const r = await api.get('/contacts/export-csv/', { responseType: 'blob' });
  const url = window.URL.createObjectURL(new Blob([r.data]));
  const a = document.createElement('a');
  a.href = url;
  a.download = 'contacts.csv';
  a.click();
  window.URL.revokeObjectURL(url);
};

export const importContactsCsv = (file: File) => {
  const form = new FormData();
  form.append('file', file);
  return api.post('/contacts/import-csv/', form).then((r) => r.data);
};
